// Eme Mater A18: guard de carregamento unico (arquivo incluido pelo PDP e pelo quick-add)
if (!window.__emeColorGroupSwatches) {
window.__emeColorGroupSwatches = true;

// Fetches the color group for the product being viewed and swaps it into the PDP.
//
// The group is derived from the parent SKU alone -- no metafield to fill in, no
// list to maintain. The element ships empty and hidden; it reveals itself only
// when the fetch comes back with two or more colors, so single-color products
// show nothing and never flash an empty row.
//
// The fragment comes from the search page under an alternate template rather than from
// the predictive-search endpoint, because only the search page hands Liquid complete
// product objects -- see templates/search.color-group.liquid for why that matters.

const SELECTOR_LIST = '[data-color-group-key]';
const SELECTOR_ITEM = '.color-group-swatches__item';
const SELECTOR_LINK = 'a.color-group-swatches__link';
const SELECTOR_VARIANT_FIELDSET = 'variant-picker fieldset';

// Nomes da opcao de cor aceitos ao decidir qual seletor nativo e redundante.
// Um nome fora desta lista simplesmente nao colapsa nada -- o pior caso e o
// comportamento anterior, nunca esconder a opcao errada.
const COLOR_OPTION_NAME = /^(cor|color|colour|cores)$/i;

const normalizePath = (value) => {
  if (!value) return '';
  return value.split('?')[0].split('#')[0].replace(/\/$/, '');
};

class ColorGroupSwatches extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    const key = this.dataset.key;
    if (!key) return;

    this.dataset.loaded = 'true';
    this.#load(key);
  }

  async #load(key) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const params = new URLSearchParams({
      q: key,
      type: 'product',
      view: 'color-group',
    });

    let markup;
    try {
      const response = await fetch(`${root}search?${params}`);
      if (!response.ok) return;
      markup = await response.text();
    } catch {
      // Offline or blocked: leave the PDP exactly as it rendered.
      return;
    }

    const list = new DOMParser().parseFromString(markup, 'text/html').querySelector(SELECTOR_LIST);
    if (!list) return;

    // A group of one is not a group -- stay hidden rather than show a lone swatch.
    if (list.querySelectorAll(SELECTOR_ITEM).length < 2) return;

    this.#markCurrent(list);
    this.replaceChildren(list);
    this.hidden = false;
    this.closest('.color-group-swatches')?.removeAttribute('hidden');
    this.#collapseRedundantColorOption();
  }

  // The fragment is page-agnostic, so the color being viewed still renders as a
  // link back to itself. Turn that one into the selected, non-navigating swatch.
  #markCurrent(list) {
    // No modal de compra rapida a pagina atual nao e a do produto; por isso o
    // elemento carrega a propria URL. No PDP os dois valores coincidem.
    const here = normalizePath(this.dataset.productUrl || window.location.pathname);

    list.querySelectorAll(SELECTOR_LINK).forEach((link) => {
      if (normalizePath(link.getAttribute('href')) !== here) return;

      link.closest(SELECTOR_ITEM)?.classList.add('is-current');
      link.setAttribute('aria-current', 'true');
      link.removeAttribute('href');
    });
  }

  // This row now owns the colour choice. Each product carries exactly one colour, so
  // the variant picker's own colour fieldset is a control offering a single option,
  // sitting directly under a second, identical "Cor" label -- the duplicate the PDP
  // showed once this feature started rendering. Collapse it, but only after a real
  // group came back: a product with no siblings keeps showing its colour as before,
  // because there the picker is the only place the colour is named.
  //
  // O teste NAO pode ser so a classe de swatch. Uma cor sem metaobjeto cadastrado
  // nao gera swatch nenhum, entao o Fabric monta a opcao como botao comum -- e o
  // seletor antigo ('fieldset.variant-option--swatches') passava direto por ela,
  // deixando um botao "MARROM CAMARU" duplicando a linha de cores. Agora o nome da
  // opcao, lido do atributo name do radio, tambem serve de sinal.
  //
  // Hidden rather than removed. The radio stays checked and stays in the form, so
  // variant selection and add-to-cart behave exactly as they did. O display inline
  // e proposital: as classes de layout do tema (.variant-option--equal-width-buttons
  // usa display:grid) venceriam o atributo [hidden] por especificidade.
  #collapseRedundantColorOption() {
    // Escopo: dentro do modal so o proprio modal. Sem isto, abrir a compra
    // rapida de um produto B estando no PDP de A colapsaria a opcao de cor de A.
    const scope = this.closest('.quick-add-modal__content') || document;
    scope.querySelectorAll(SELECTOR_VARIANT_FIELDSET).forEach((fieldset) => {
      const radios = fieldset.querySelectorAll('input[type="radio"]');
      if (radios.length !== 1) return;

      const isSwatchFieldset = fieldset.classList.contains('variant-option--swatches');
      const optionName = (radios[0].name || '').split('-')[0];
      if (!isSwatchFieldset && !COLOR_OPTION_NAME.test(optionName)) return;

      fieldset.style.display = 'none';
    });
  }
}

if (!customElements.get('color-group-swatches')) {
  customElements.define('color-group-swatches', ColorGroupSwatches);
}

}
